<template>
	<div>
		<div class="title row">
			<div>
    			<h1>Editer votre profil<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
			</div>
		</div>
		<div class="row main-wrap">
			<div class="profil-view">
				<div class="onglet">
				  <h3>Mon profil</h3>
				</div>
				<form class="section-bg" v-on:submit="update">
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="nom" v-if="utilisateur">{{ utilisateur.user.name }} {{ utilisateur.user.surname }}</h3>
                        </div>
                        <div class="col-md-12">
                            <h4 class="role" v-if="utilisateur">{{ utilisateur.role }}</h4>
                        </div>
                    </div>
					<div class="row">
                        <div class="form-group col-sm-6">
							<label for="email">E-mail</label>
							<input type="email" id="email" class="form-control" v-model="utilisateur.user.email" required v-if="utilisateur">
						</div>
						<div class="form-group col-sm-6">
							<label for="password">Password</label>
							<input type="password" id="password" class="form-control" v-model="utilisateur.user.password" required v-if="utilisateur">
						</div>
                    </div>
                    <hr class="hr-text" data-content="clients assignés">
					<div class="row clients-assignes-titre">
						<div class="col-xs-8">Client</div>
						<div class="col-xs-4 text-center">Nombre de jours assignés</div>
					</div>
					<template v-for="client in allClients" v-if="utilisateur">
						<div class="row clients-assignes-content" v-for="utilisateurclient in client.utilisateur" v-if="utilisateur && utilisateur.id == utilisateurclient.id">
							<div class="col-xs-8">
								{{ client.user.name }}
							</div>
							<div class="col-xs-4 text-center">
								{{ client.utilisateur[0].temps.temps }}
							</div>
						</div>
					</template>
					<div class="submit-btn">
						<button type="submit" class="green-btn">Sauvegarder</button>
					</div>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
   @import '../sass/app.scss';
</style>

<script>

    import Vue from '../js/app.js'

	export default {
	  	data() {
	    	return {
                utilisateur: null,
                current_id: localStorage.id_user,
                allClients : null,
            }
        },
	    beforeCreate: function() {
			this.$nextTick(function() {
                this.showUtilisateur();
                this.clients();
            });
        },
        methods: {
	    	showUtilisateur(){
                Vue.http.post(
                    'api/utilisateurs/show',
                    {
                        id: this.current_id
                    }
                ).then(response => {
                    this.utilisateur = response.data.data;
                })
            },
            clients() {
                Vue.http.get(
                    'api/client/',
                ).then(response => {
                    this.allClients = _.orderBy(response.data.data, 'name')
                })
            },
            update() {
                event.preventDefault();
                Vue.http.post(
                    'api/utilisateurs/updateConsultant',
                    {
                        idutilisateur: this.utilisateur.id,
                        iduser: this.utilisateur.iduser,
                        email: this.utilisateur.user.email,
                        password: this.utilisateur.user.password
                    }
                )
            },
        }
    }

</script>



// WEBPACK FOOTER //
// Profil.vue?1c847e0a